export const useBuildVersion = () => {
  const { public: env } = useRuntimeConfig()
  const LINE_WIDTH = 60
  const projectName = env.projectName.toUpperCase()
  const version = env.version

  const centerAlign = (content = '', width = LINE_WIDTH) => {
    const padding = Math.max(0, (width - content.length) / 2)
    return (
      ' '.repeat(Math.floor(padding)) + content + ' '.repeat(Math.ceil(padding))
    )
  }
  const green = 'color: green; font-weight: bold;'

  onMounted(() => {
    console.info(
      '%c' + centerAlign(`[${projectName} Build Version]: ${version}`),
      green,
    )
  })
}
